import React, { Component } from "react";
import "../Users/Users.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import moment from "moment";
import * as languageSettings from "../Language/languageSettings";
import t from "../Language/language";
import { Config } from "../../Config";
import Api from "../../Api";
import { getLeaderBoardList, sortLeaderBoard } from "../../actions/leaderBoardGroups";
import AuthenticationService from "../Security/AuthenticationService";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import CommonLoader from "../Alerts/CommonLoader";
import whiteplus from "../../images/whiteplus.png";
import { get, save, remove, getCompanyDetail } from "../../actions/leaderboardGroup";
import { confirmAlert } from "react-confirm-alert";
import { isNullOrUndefined } from "util";
import { checkAccess } from '../../actions/permissions'
import { CommonConstants } from '../../Constants'
const LeaderboardAd = require("../../images/Leaderboard_Ad.png");

const _ = require("underscore");
const removeBtn = require("../../images/target_dot.png");

class LeaderBoardGroups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      Ascending: true,
      showCommonLoader: false,
      groups: [],
      successMessage: "",
      errorMessage: "",
      saveSuccess: false,
      deleteSuccess: false,
      companyDetails: {},
    };
    this.api = new Api();
    this.authService = new AuthenticationService(Config.authBaseUrl);
    this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin());
    this.deleteGroup = this.deleteGroup.bind(this);
    this.unitTests = {
      initialized: null,
      componentLoaded: null,
      tableInitialized: null,
      tableHasData: null,
    };
  }

  componentWillMount() {
    this.setState({ showCommonLoader: true });
    this.props.getCompanyDetail(data => {
      if (data.status === false) {
        this.setState({ successMessage: data.data, errorMessage: "" });
      } else {
        this.setState({ companyDetails: data });
      }
      this.props.sortLeaderBoard({ sortBy: "Group_Name", sortType: "ASC" });
      this.props.getLeaderBoardList(() => {
        const groups = this.props.leaderBoardGroups;
        this.setState({ groups });
        this.setState({ showCommonLoader: false });
      }, data.companyUId);
    });

    this.setState({ showCommonLoader: false });
    this.unitTests.componentLoaded = true;
  }

  handleClick(did) {
    if (this.authService.isAdmin()) {
      window.location.href = `/admin/settings/users/user?uuid=${did}`;
    } else {
      window.location.href = `/settings/users/user?uuid=${did}`;
    }
  }

  // Renders the table container, its header columns, and the add group button
  render() {
    const { language } = this.state;
    const sortParams = this.props.leaderBoardGroups.sortParams ? this.props.leaderBoardGroups.sortParams : { sortBy: "Group_Name", sortType: "DESC" };
    this.unitTests.initialized = true;
    let isValidUserPerm = this.authService.getProfile().SL === 2 && (checkAccess(CommonConstants.userPermissions.EditLeaderboard) || this.authService.getProfile().IsAccountOwner === 1);
    // console.log("Permissions 1: ", isValidUserPerm);
    // console.log("Permissions 2: ", this.props.permissions.userPermissions);
    // console.log("Permissions 3: ", this.authService.getProfile());

    if (isValidUserPerm) {
      return (
        <section className="users">
          <CommonLoader showLoader={this.state.showCommonLoader} message="Loading..." />
          <div className={`settings forms ${!this.state.showCommonLoader ? "" : "hidden"}`}>
            <div className="settings_plug clear">
              <div className="systemsHeader">
                <h3 className="clear" style={{ margin: "0px" }}>
                  {t[language].Leaderboards}
                </h3>
              </div>
            </div>
            <div className={isValidUserPerm ? "addUserButton settings_plug clear paddingOnTop" : "paddingOnTop"} onClick={this.addLBGroup.bind(this)}>
              <span className="additem">
                <img src={whiteplus} className="whiteplus" />
                {t[language].AddLeaderboard}
              </span>
            </div>{" "}
            <div className="settings_plug clear storeHeight paddingOnTop" />
            <div className="settings_list">
              <div className="ctable">
                <Table>
                  <Thead>
                    <Tr className="theader clear">
                      <Th>
                        <span id="Group_ViewLB" />
                      </Th>
                      <Th id="Group_Name">
                        <span id="GroupName">{t[language].Leaderboard}</span>
                      </Th>
                      <Th>
                        <span id="Group_RankingCriteria">{t[language].Description}</span>
                      </Th>
                      <Th>
                        <span id="Group_StoreCount">{t[language].stores}</span>
                      </Th>
                      <Th>
                        {t[language].Remove} {t[language].Leaderboard}
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>{this.renderLBGroups()}</Tbody>
                </Table>
              </div>
            </div>
          </div>
        </section>
      );
    } else if (this.authService.getProfile().SL != 2){
      return (
        <section className="users">
          {/* <CommonLoader showLoader={this.state.showCommonLoader} message="Loading..." /> */}
          <div>
            <h4>
              {t[language].LeaderboardAd1}
              <br />
              <br />
              {t[language].LeaderboardAd2} <a>{t[language].LeaderboardAdPhone1}</a> {t[language].LeaderboardAd3}
              <a>{t[language].LeaderboardAdPhone2}</a>
            </h4>
            <div>
              <img className="leaderboardAd" src={LeaderboardAd} />
            </div>
          </div>
        </section>
      );
    } else if (this.authService.getProfile().SL === 2 && !checkAccess(CommonConstants.userPermissions.EditLeaderboard)){
      return (
        <section className="users">
          {/* <CommonLoader showLoader={this.state.showCommonLoader} message="Loading..." /> */}
          <div>
            <h4>
              {t[language].LeaderboardAd1}
              <br />
              <br />
              {t[language].LeaderboardNoEditPerm}
            </h4>
            <div>
              <img className="leaderboardAd" src={LeaderboardAd} />
            </div>
          </div>
        </section>
      );
    }
  }

  // Resorts the LB
  sortLeaderBoard(e) {
    const sortBy = e.target.id;
    const sortType = !this.state.Ascending ? "DESC" : "ASC";
    const sortParams = { sortBy, sortType };
    this.setState(this.state);
    this.props.sortLeaderBoard(sortParams);
    this.props.getLeaderBoardList(() => {
      const groups = this.props.leaderBoardGroups;
      this.setState({ groups });
      this.setState({ showCommonLoader: false });
    }, this.state.companyDetails.companyUId);
    this.setState({ Ascending: !this.state.Ascending });
  }

  addLBGroup() {
    window.location.href = "/leaderBoards/leaderboardGroup";
  }

  editGroup(item, companyUID, e) {
    window.location.href = `/leaderBoards/leaderboardGroup?GroupUID=${item.GroupUID}&IsDefault=${item.IsDefault}&ia=${companyUID === item.GroupOwner}`;
  }

  // Render individual challenge/group members into the group table. Note that groups without an associated "owner" companyUID will not appear here as they are not found by the sproc.
  renderLBGroups() {
    const { language } = this.state;
    const self = this;
    const unitTests = Object.assign({}, this.state.unitTests);
    unitTests.tableInitialized = true;

    if (this.props.leaderBoardGroups.list) {
      if (this.props.leaderBoardGroups.list.length > 0) {
        unitTests.tableHasData = true;
        const rows = this.props.leaderBoardGroups.list.map(function(item) {
          // Handle if group is default group so that group name is not returned "null"
          let isDefault = false;
          if (isNullOrUndefined(item.GroupID) || item.IsDefault) {
            isDefault = true;
          }
          //console.log("Company UID: ", self.state.companyDetails.companyUId)
          // console.log("Item test: ", item)
          //console.log("Default: ", self.state.companyDetails.companyUId != item.GroupOwner)
          return (
            <Tr className="tdata clear" key={item.GroupID}>
              <Td>
                <a
                  className={item.Group_StoreCount > 0 ? "view_details cursor-pointer" : "hidden"}
                  href={null}
                  onClick={() => window.open(Config.leaderboardsBaseUrl + item.MaxStoreUID, "Leaderboard", "width=800,height=450")}
                >
                  {t[language].View}
                </a>
              </Td>
              <Td>
                <a className="cursor-pointer" onClick={self.editGroup.bind(this, item, self.state.companyDetails.companyUId)}>
                  {item.Group_Name}
                </a>
                {isDefault && self.state.companyDetails.companyUId === item.GroupOwner ? " (" + t[language].DefaultGroup + ")" : ""}
              </Td>
              <Td>{item.Group_Desc}</Td>
              <Td>{item.Group_StoreCount || "0"}</Td>
              <Td className="redText cursor-pointer">
                <strong className="pushToTheRight" onClick={() => self.deleteGroup(item.GroupUID)}>
                  {isDefault || self.state.companyDetails.companyUId != item.GroupOwner ? "" : "X"}
                </strong>
              </Td>
            </Tr>
          );
        });
        return rows;
      }
    } else {
      unitTests.tableHasData = false;
      return <Tr />;
    }
  }

  // Method for removing leaderboards/groups.
  deleteGroup(GroupUID) {
    const { language } = this.state;
    confirmAlert({
      title: t[language].confirmRemoval,
      message: t[language].areyousureremovegroup,
      buttons: [
        {
          label: t[language].yes,
          onClick: () => {
            this.setState({ showCommonLoader: true });
            const { language } = this.state;
            this.props.remove({ GroupUID: GroupUID, CompanyUID: this.state.companyDetails.companyUId }, data => {
              if (data.status === true) {
                const self = this;
                this.setState({ successMessage: t[language].data });
                this.setState({ errorMessage: "" });
                this.setState({ deleteSuccess: true });
                this.props.getLeaderBoardList(() => {
                  const groups = this.props.leaderBoardGroups;
                  this.setState({ groups });
                  this.setState({ showCommonLoader: false });
                }, this.state.companyDetails.companyUId);
                this.props.history.push("/message", data.data);
                setTimeout(() => {
                  self.props.history.push("/leaderBoards");
                }, 3000);
              } else {
                this.setState({ errorMessage: t[language].data });
                this.setState({ successMessage: "" });
                this.props.getLeaderBoardList(() => {
                  const groups = this.props.leaderBoardGroups;
                  this.setState({ groups });
                  this.setState({ showCommonLoader: false });
                }, this.state.companyDetails.companyUId);
              }
            });
          },
        },
        {
          label: t[language].no,
          onClick: () => {},
        },
      ],
    });
  }
}

function mapStateToProps(state) {
  return {
    leaderBoardGroups: state.leaderboardGroups.leaderBoardGroups,
    permissions: state.permissions,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getCompanyDetail: getCompanyDetail,
      getLeaderBoardList,
      sortLeaderBoard,
      save,
      remove,
      get,
    },
    dispatch,
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps,
)(LeaderBoardGroups);



// WEBPACK FOOTER //
// ./src/components/LeaderBoard/LeaderBoardGroups.js